import { CircularProgressbar } from 'react-circular-progressbar';
import { MBView } from '@shared/components/MBView';
import { MBProgressBarProps } from '../props';
import { Styles, UnvalidatedStyles } from '../styles';

/*
    Circular progress bar that animates progress updates. For reference:
    https://github.com/iqnivek/react-circular-progressbar
*/
export function MBCircularProgressBar({
  progress,
  size = 'normal',
  color = UnvalidatedStyles.defaultProgressBarColor,
  unfilledColor = UnvalidatedStyles.defaultProgressBarUnfilledColor,
}: MBProgressBarProps) {
  return (
    <MBView
      style={[
        size === 'normal' && Styles.circularProgressBarNormalSize,
        size === 'small' && Styles.circularProgressBarSmallSize,
      ]}
    >
      <CircularProgressbar
        value={progress * 100}
        strokeWidth={12}
        styles={{
          path: { stroke: color, transition: 'stroke-dashoffset 0.5s ease 0s' },
          trail: { stroke: unfilledColor },
        }}
      />
    </MBView>
  );
}
